import template from "./tiny-mce.html";

const TinyMceComponent = {
  bindings: {
    section: "<",
    sectionIndex: "<",
    tinymceOptions: "<",
    contentToModify: "<",
    onChange: "&",
  },
  template: template,
  controller: class TinyMceController {
    /* @ngInject */
    constructor($scope, $element, $rootScope, $timeout, Utils) {
      this.$scope = $scope;
      this.$element = $element;
      this.$rootScope = $rootScope;
      this.$timeout = $timeout;
      this.Utils = Utils;
    }

    $onInit() {
      this.timeoutPromise = null;
    }

    changeContent() {
      this.$timeout.cancel(this.timeoutPromise);
      this.timeoutPromise = this.$timeout(() => {
        this.onChange({ section: this.section });
      }, 3000);
    }
  },
};

export default TinyMceComponent;
